{{ subpointCount$ | async | i18nPlural: subpointCountMapping }}
